import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer>
      <p>-- Desgined & built by Bradley Owens --</p>
    </footer>
  );
};

export default Footer;
